import { useState, useEffect } from 'react'
import ReactTooltip from 'react-tooltip'
import { Flex, Box, Text, Heading, Card } from 'rebass/styled-components'
import styled from 'styled-components'
import { ITag } from '../graphql/types/queries/conversation'

const TagWrap = styled(Flex)`
  height: 18px;
  padding: 0 4px;
  align-items: center;
  border-radius: 2px;
  overflow: hidden;
  position: relative;
`

interface ITagProps {
  onDelete?: () => void
  tag: ITag
}

export const Tag: React.FC<ITagProps> = ({ onDelete, tag }) => {
  return (
    <TagWrap mr={2}>
      <Box style={{
        position: 'absolute',
        left: 0,
        right: 0,
        top: 0,
        bottom: 0,
        backgroundColor: tag.color,
        opacity: 0.75,
      }} />
      <Text style={{ zIndex: 1 }} color={'white'} fontSize={'13px'}>{tag.tag}</Text>
      {!!onDelete && (
        <>
          <Text style={{ zIndex: 1 }} color={'white'} fontSize={'13px'} ml={2} data-tip='remove tag'>X</Text>
          <ReactTooltip place="bottom" type="dark" effect='float' />
        </>
      )}
    </TagWrap>);
}